export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  SHOPIFY_PENDING_INSTALL: 'shopifyPendingInstall',
};
